import * as React from "react"

function SvgFeatherMinus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather-minus_svg__feather feather-minus_svg__feather-minus"
      {...props}
    >
      <path d="M5 12h14" />
    </svg>
  )
}

export default SvgFeatherMinus
